import React, { memo, useCallback, useContext, useEffect, useMemo, useState } from 'react';

import { Box, Flex, Stack } from '@chakra-ui/layout';
import {
  AuthorizeView,
  AutocompleteInput,
  Button,
  Loading,
  SelectInput,
  TextInput,
  Unform,
} from 'components';
import ROPA from 'models/Forms/ROPA';
import { IROPAProps, ROPACtx } from 'pages';
import { TextAreaInput } from '../../../../components/Unform/TextAreaInput';
import { TargetInfortmation } from 'constants/tooltips';
import { checkPermission } from 'utils/authentication';
import { getAllClients } from 'services/client';
import { getCommonProps } from 'utils/CommonPropperties';
import { getLoggedUser } from 'utils/storage';
import { setItemStorage } from 'services/storage';

type ClientProps = {
  name: string;
  id: React.ReactText;
};

const Item: React.FC<IROPAProps> = ({ functionCallback, index, submit, completed }) => {
  const ctx = useContext(ROPACtx);
  const [loading, setLoading] = useState(false);
  const [clients, setClients] = useState<{ name: string; id: React.ReactText }[]>([]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectClientName, setSelectClientName] = useState<string | undefined>('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectClientId, setSelectClientId] = useState<number | undefined>();

  const cProps = useMemo(() => getCommonProps(ctx.isDetails), [ctx.isDetails]);
  const handleSubmit = useCallback(
    async (data: ROPA) => {
      localStorage.setItem('load', String(Math.random()));

      setLoading(true);
      if (submit) {
        const resp = await submit(data, '1 - Descrição');
        if (resp) {
          functionCallback(index + 1);
        }
      } else {
        functionCallback(index + 1);
      }
      setLoading(false);
    },
    [submit, functionCallback, index],
  );

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async function nextPage() {
    setLoading(true);
    if (submit) {
      const resp = await submit();
      if (resp) {
        functionCallback(index + 1);
      }
    } else {
      functionCallback(index + 1);
    }
    setLoading(false);
  }

  useEffect(() => {
    if (checkPermission({ onlyAdmin: true })) {
      (async () => {
        const { data } = await getAllClients('');
        setClients(data);
      })();
    }
  }, []);

  useEffect(() => {
    if (ctx.isDetails && clients.length > 0) {
      if (ctx.setClient) ctx.setClient(clients.find(i => i.id === ctx.data.clientId));
    }
  }, [ctx.isDetails, clients]);

  const clientSelect = clients.find(i => +i.id === +(getLoggedUser().client || '')) as ClientProps;

  const handleSelectClient = (params: {
    optionValue: any;
    selectMethod: 'mouse' | 'keyboard' | null;
    isNewInput: boolean;
  }) => {
    const selectedClient = clients?.find(clientArr => clientArr.id === params.optionValue);
    const selectClientName = clients?.find(clientArr => clientArr.id === params.optionValue);
    setItemStorage('selectedClient', selectedClient?.id);
    setSelectClientName(selectClientName?.name);
    setSelectClientId(Number(selectClientName?.id));
  };

  return (
    <Flex marginTop="1rem" width="100%" direction="column">
      <Unform
        initialData={ctx.data}
        onSubmit={handleSubmit}
        // validationSchema={OrientedInformationValidationSchema}
      >
        {!ctx.isDetails ? (
          <AuthorizeView onlyAdmin>
            <Box mb="20px">
              {clients.length > 0 ? (
                !getLoggedUser()?.client ? (
                  <AutocompleteInput
                    name="clientId"
                    optionLabel="name"
                    optionValue="id"
                    label="Cliente/Empresa"
                    options={
                      clients
                        ?.map(client => ({ name: client.name, id: client.id }))
                        .sort((a, b) => {
                          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                        }) || []
                    }
                    {...cProps}
                  />
                ) : (
                  <SelectInput
                    name="clientId"
                    optionLabel="name"
                    optionValue="id"
                    label="Cliente/Empresa"
                    onSelectOption={handleSelectClient}
                    options={
                      clients
                        ?.map(client => ({ name: client.name, id: client.id }))
                        .sort((a, b) => {
                          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                        }) || []
                    }
                    defaultValues={[clientSelect]}
                    {...cProps}
                    disabled
                  />
                )
              ) : (
                <Loading />
              )}
            </Box>
          </AuthorizeView>
        ) : (
          <AuthorizeView onlyAdmin>
            <Box mb="20px">
              {clients.length > 0 ? (
                <AutocompleteInput
                  name="clientId"
                  optionLabel="name"
                  optionValue="id"
                  label="Cliente/Empresa"
                  options={
                    clients
                      ?.map(client => ({ name: client.name, id: client.id }))
                      .sort((a, b) => {
                        return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
                      }) || []
                  }
                  placeholder={ctx.client?.name}
                  defaultValue={ctx.client}
                  // {...cProps}
                />
              ) : (
                <Loading />
              )}
            </Box>
          </AuthorizeView>
        )}
        {checkPermission({ onlyAdmin: true }) ? (
          <>
            <Box>
              <TextInput
                tip={TargetInfortmation[0].label}
                label="Atividade de tratamento de dados"
                name="name"
                // {...cProps}
              />
            </Box>

            <Box>
              <TextInput
                tip={TargetInfortmation[1].label}
                label="Responsável pela atividade"
                name="responsable"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={TargetInfortmation[2].label}
                label="Descrição da atividade"
                name="description"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextInput
                tip={TargetInfortmation[3].label}
                label="Área responsável pela atividade"
                name="area"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={TargetInfortmation[4].label}
                label="Qual a finalidade da atividade?"
                name="purpose"
                // {...cProps}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={TargetInfortmation[5].label}
                label="Quais são os dados envolvidos nessa atividade?"
                name="whichData"
                // {...cProps}
              />
            </Box>
            {ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  {/* <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button> */}
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
            {!ctx.isDetails && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  {/* <Button
                    type="button"
                    variant="primary"
                    outline
                    onClick={() => functionCallback(index - 1)}
                  >
                    Voltar
                  </Button> */}
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        ) : (
          <>
            <Box>
              <TextInput
                tip={TargetInfortmation[0].label}
                label="Atividade de tratamento de dados"
                name="name"
                isDisabled={completed}
                disabled={completed}
              />
            </Box>

            <Box>
              <TextInput
                tip={TargetInfortmation[1].label}
                label="Responsável pela atividade"
                name="responsable"
                isDisabled={completed}
                disabled={completed}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={TargetInfortmation[2].label}
                label="Descrição da atividade"
                name="description"
                isDisabled={completed}
                disabled={completed}
              />
            </Box>
            <Box>
              <TextInput
                tip={TargetInfortmation[3].label}
                label="Área responsável pela atividade"
                name="area"
                isDisabled={completed}
                disabled={completed}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={TargetInfortmation[4].label}
                label="Qual a finalidade da atividade?"
                name="purpose"
                isDisabled={completed}
                disabled={completed}
              />
            </Box>
            <Box>
              <TextAreaInput
                rows={3}
                resize="none"
                tip={TargetInfortmation[5].label}
                label="Quais são os dados envolvidos nessa atividade?"
                name="whichData"
                isDisabled={completed}
                disabled={completed}
              />
            </Box>
            {!completed && (
              <Box width="100%">
                <Stack direction={['column', 'row']} spacing="1rem" mt="1rem" justify="flex-end">
                  <Button
                    type="submit"
                    variant="primary"
                    // onClick={nextPage}
                    isLoading={loading}
                    disabled={loading}
                  >
                    Próximo
                  </Button>
                </Stack>
              </Box>
            )}
          </>
        )}
      </Unform>
    </Flex>
  );
};

export const OrientedInformation = memo(Item);
